<template>
    <span :class="{ 'selected-part-text': highlightSelected && displayMeta.isExactMatch }">
        {{ displayMeta.text }}
    </span>
    <span v-if="showBadge && displayMeta.isSubstitute" class="sub-badge">
        {{ badgeText }}
    </span>
</template>

<script>
    import { normalizePart } from '@/helpers/string.js'

    export default {
        name: 'PartNumberDisplay',
        props: {
            partNumber: {
                type: [String, Number],
                default: '',
            },
            selectedPart: {
                type: [String, Number],
                default: '',
            },
            badgeText: {
                type: String,
                default: 'Sub',
            },
            showBadge: {
                type: Boolean,
                default: true,
            },
            highlightSelected: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            displayMeta() {
                const rawPart = (this.partNumber || '').toString().trim()
                if (!rawPart) {
                    return {
                        isExactMatch: false,
                        text: '-',
                        isSubstitute: false,
                    }
                }

                const normalizedPart = normalizePart(rawPart)
                const normalizedSelected = normalizePart(this.selectedPart)
                const isExactMatch =
                    Boolean(normalizedSelected) &&
                    Boolean(normalizedPart) &&
                    normalizedPart === normalizedSelected

                return {
                    isExactMatch,
                    text: rawPart,
                    isSubstitute: !isExactMatch && Boolean(normalizedSelected) && Boolean(normalizedPart),
                }
            },
        },
    }
</script>

<style scoped>
    .selected-part-text {
        color: var(--color-brand-primary);
        font-weight: 800;
    }

    .sub-badge {
        background: var(--color-surface-subtle);
        border-radius: var(--radius-pill);
        color: var(--color-text-muted);
        display: inline-block;
        font-size: 0.7rem;
        font-weight: 700;
        line-height: 1;
        margin-left: 0.4rem;
        padding: 0.2rem 0.45rem;
        text-transform: uppercase;
        vertical-align: middle;
    }
</style>
